import axios from 'axios';

import {
  axiosConfig,
  serverUrl,
} from '../../config';
// eslint-disable-next-line import/no-cycle
export type AdsDelay = {
  totalDelay: number,
  count: number
};

export type Log = {
  pops: number;
  failedPops: number;
  adsQueued: number;
  adRequests: number
  latestAdRequest: number | null
  adsDelay: number | null;
};

export const registerLog = (log: Log): void => {
  console.log('registering log...');
  // axios.post(`${streetsUrl}/logs`, { deviceId: window.DeviceApi.getDeviceId(), ...log }, axiosConfig).catch((err) => console.log(`Error registering log: ${err}`));
  axios.post(`${serverUrl}/external/logs`, { deviceId: window.DeviceApi.getDeviceId(), ...log }, axiosConfig).catch((err) => console.log(`Error registering log: ${err}`));
};
